/*
  assets/menu-drawer-links.js

  Lets the level 1 and level 2 titles in the mobile menu drawer behave as links.

  The markup change is in `snippets/menu-drawer-details.liquid`: the title is now
  an `<a>` inside the `<summary>`, and the caret / plus beside it is what opens
  the level below. The browser handles that correctly on its own - clicking a link
  inside a `summary` runs the anchor's activation behaviour and not the summary's,
  so the sub-level does not open behind the navigation.

  What does not handle it correctly is the theme's own click listeners on those
  summaries, which fire for any click anywhere inside:

  - `MenuDrawerDetails.onSummaryClick` (assets/header.js) adds `.active`, which
    slides the sub-panel over the top while the browser is still navigating.
  - `AccordionDetails.toggleAccordion` (assets/theme.js) calls
    `event.preventDefault()`, which cancels the navigation outright. Level 2 links
    would simply not work.

  So this intercepts the click in the **capture** phase, before either listener is
  reached, and stops it propagating. `stopPropagation` does not set
  `defaultPrevented`, so the anchor still navigates.

  It is a separate file rather than an edit to header.js or theme.js on purpose:
  both are vendor files that a Hyper update would overwrite, and
  `toggleAccordion` is shared by every accordion in the theme - product tabs, the
  cart, collapsible tabs. Guarding from the outside leaves all of them untouched.

  Paired with `assets/menu-drawer-links.css`. Loaded from `sections/header.liquid`
  alongside `header.js`.
*/
(function () {
  var drawer = document.getElementById('MenuDrawer');
  if (!drawer) return;

  drawer.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a.menu-drawer__item-title-link');
      if (!link) return;

      // Only the summary listeners are a problem. A title link that somehow sits
      // outside one needs no help and should keep bubbling normally.
      if (!link.closest('summary')) return;

      event.stopPropagation();
    },
    true
  );
})();
